<template>
  <div class="overall-bg pt-0">
    <b-container class="form-white-bg pt-0" ref="aboveContainer">
      <b-form @submit.prevent="IsSubmit">
        <b-row class="stepperdiv">
          <b-col lg="6" md="6" sm="6" cols="2">
            <BackBtn :goback="$router.back" />
            <Headerlayout headertext="GRN Return"></Headerlayout>
          </b-col>
          <b-col
            lg="6"
            md="6"
            sm="6"
            cols="2"
            v-if="IsGRNDetails == 0"
            class="flex flex-row-reverse"
          >
            <!-- <AddButton btnname="Save" @click="IsSubmit()" :loading="SaveLoader" />
            <Cancel /> -->
            <Footer
              v-if="!afterSave"
              class="py-2"
              :goback="$router.back"
              :loading="SaveLoader"
            />
          </b-col>
        </b-row>
        <div v-if="paramValue == 'GRNReturn'" class="row">
          <b-row>
            <b-col lg="2" md="4" sm="6">
              <div class="field">
                <label>Code</label>

                <p class="common-heading">{{ createrequestForm.DocNo }}</p>
              </div>
            </b-col>
            <b-col lg="2" md="4" sm="6">
              <div class="field">
                <label>Return Date</label>

                <p class="common-heading">{{ GRNForm.docDate }}</p>
              </div>
            </b-col>
          </b-row>

          <p class="component-heading"></p>
          <b-row>
            <b-col lg="3" md="6" sm="6" cols="10" v-if="HiddenRefNo != ''">
              <div class="field">
                <label>GRN Number</label>

                <AutoCompleteCustom
                  name="GRN Number"
                  label="GRN Number"
                  id="GRN Number"
                  v-model="GRNForm.refNo"
                  :required-icon="true"
                  :rules="{ required: true, alphanumeric: true }"
                  :items="supcategory"
                  @item-select="ongrnchange"
                  @input="grnautogen()"
                  :disabled="GRNForm.disabled || afterSave"
                />
              </div>
            </b-col>
            <b-col
              lg="3"
              md="6"
              sm="6"
              cols="10"
              v-if="false && HiddenRefNo != ''"
            >
              <div class="field">
                <Datepicker
                  id="GRN Date"
                  v-model="GRNForm.docDate"
                  label="GRN Return Date"
                  name="GRN Date"
                  :required-icon="true"
                  :rules="{ required: true }"
                  :disabled="GRNForm.disableddate || afterSave"
                />
              </div>
            </b-col>
            <b-col lg="3" md="6" sm="6" cols="10" v-if="HiddenRefNo != ''">
              <div class="field">
                <label>GRN Date</label>
                <p class="common-heading">{{ GRNForm.GRNDocDate }}</p>
              </div>
            </b-col>
            <b-col lg="3" md="6" sm="6">
              <div class="field">
                <CustomDropdown
                  :required-icon="true"
                  label="Return Type"
                  :rules="{ required: true }"
                  name="Return Type"
                  id="Return Type"
                  v-model="createrequestForm.ReturnType"
                  :items="returnOption"
                  :disabled="IsGRNDetails == 1 || afterSave"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <Supplier
                :showone="paramValue"
                v-model="SupformData"
                :supplierDeatails="itemDatas"
                :disabled="DisableObj.Supplier || afterSave"
                :commonItemProps="commonProps"
                @SupplierId="getSupplier(SupformData)"
              />
            </b-col>
            <b-col class="d-flex flex-row-reverse" v-if="afterSave">
              <div class="colourCodeStatusBg">
                <div class="confirmationtime" v-for="i1 in colourCodeList">
                  <div class="d-flex align-items-center gap-2">
                    <div
                      class="confirmedicon"
                      :style="{ backgroundColor: i1.OrderColor }"
                    ></div>
                    <p>{{ i1.StatusName }}</p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="QueryStringValue3['IsGRNDetails'] == 0 && !afterSave">
            <b-col class="d-flex flex-row-reverse">
              <p
                class="add-items d-flex d-flex-row-reverse pb-3"
                v-b-toggle.collapse-3
              >
                + Add New
              </p>
            </b-col>
          </b-row>
          <b-row v-if="!afterSave">
            <b-col>
              <b-collapse id="collapse-3" :class="displayClass">
                <Items
                  @additemclick="AddItems"
                  v-model:data-items="dataItems"
                  :show-fields="showFields"
                  :addItemData="items"
                  @calculation="TotalGrossCalc"
                  :commonItemProps="commonItemProps"
                  :isFilterData="itemDatas"
                  @taxcalculation="taxCalculation"
                />
              </b-collapse>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col>
            <Tableview
              v-model:value="items"
              class="p-datatable-gridlines"
              :rows="10"
              :rowHover="true"
              filterDisplay="menu"
              responsiveLayout="scroll"
              :columns="headers"
              :globalFilterFields="globalFilterFields"
              :filters="filters"
            >
              <template v-slot:action="{ data }">
                <!-- v-if="QueryStringValue3['Id'] == 0" -->
                <span
                  v-if="
                    QueryStringValue3['IsGRNDetails'] == 0 &&
                    data.ReplacementStatus != '2'
                  "
                >
                  <EditIcon v-if="!afterSave" @click="IsItemEdit(data)" />
                  <DeleteIcon v-if="!afterSave" @click="IsItemDelete(data)" />
                </span>
              </template>
              <template v-slot:ExpiryDateslot="{ data }">
                <span v-if="data.ExpiryDate != '01 Jan 1900'">
                  {{ data.ExpiryDate }}
                </span>
                <span v-else>
                  {{ " - " }}
                </span>
              </template>
              <template v-slot:combinedFieldSlot="{ data }">
                <span>
                  <template v-if="data.BrandName">{{
                    data.BrandName
                  }}</template>
                  <template v-if="data.BrandName && data.ModelNumberName"
                    >/</template
                  >
                  <template v-if="data.ModelNumberName">{{
                    data.ModelNumberName
                  }}</template>
                  <template
                    v-if="
                      (data.BrandName || data.ModelNumberName) && data.SizeName
                    "
                    >/</template
                  >
                  <template v-if="data.SizeName">{{ data.SizeName }}</template>
                </span>
              </template>
              <template v-slot:combinedBin="{ data }">
                <span>
                  <template v-if="data.RoomName">{{ data.RoomName }}</template>
                  <template v-if="data.RoomName && data.RackName">/</template>
                  <template v-if="data.RackName">{{ data.RackName }}</template>
                  <template
                    v-if="(data.RoomName || data.RackName) && data.RowName"
                    >/</template
                  >
                  <template v-if="data.RowName">{{ data.RowName }}</template>
                  <template
                    v-if="
                      (data.RoomName || data.RackName || data.RowName) &&
                      data.BoxName
                    "
                    >/</template
                  >
                  <template v-if="data.BoxName">{{ data.BoxName }}</template>
                </span>
              </template>
              <template v-slot:ReplacementStatusSlot="{ data }">
                <span>
                  <GreenStatus
                    name="Completed"
                    v-if="data.ReplacementStatus == '2'"
                  />
                  <BlueStatus
                    name="Partial"
                    v-if="data.ReplacementStatus == '1'"
                  />
                </span>
              </template>
              <template v-slot:Itemname1="{ data }">
                <span :style="getColorStyle(data)">
                  {{ data.Itemname1 }}
                </span>
              </template>
            </Tableview>
          </b-col>
        </b-row>
        <b-row class="form-white-bg justify-content-end">
          <b-col lg="4" md="4" sm="12" cols="12">
            <FooterSection
              v-model="createrequestForm"
              :status="1"
              :grossvalue="createrequestForm"
              :flagval="true"
            />
          </b-col>
        </b-row>
      </b-form>
    </b-container>

    <Toast />
    <EditConfirmation
      :Editmodel="Editmodel"
      @yes="addQuantity"
      @no="(Editmodel = false), IsClear"
      content="Item already added, Do you want to add more Quantity ?"
    />
    <CreateSuccessully :visible="popup.successpop" @ok="closetrigger()" />
    <UpdatedSuccessfully :visible="popup.updatepop" @ok="closetrigger()" />
    <CrystalReportPrintPopUp
      :ShowAndHide="CrystalReportPopup"
      :ParameterValues="ParameterValues"
      :PrintType="PrintType"
    />
    <AlreadyExist
      :selectedcontent="selectedcontent"
      :visible="alreadyexistpop"
      @ok="alreadyclosetrigger()"
    />
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  PropType,
  computed,
  onMounted,
  watch,
} from "vue";
import BackBtn from "../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import Tableview from "../../../../../components/FormComponents/NormalTable.vue";
import Supplier from "../../../../../modules/Inventory/components/Transaction/SupplierComponent.vue";
import PurchaseOrder from "../../../../../modules/Inventory/components/Transaction/PurchaseOrder.vue";
import Return from "../../../../../modules/Inventory/components/Transaction/Return.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import Items from "../../../../../modules/Inventory/components/Transaction/Item.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import { useRoute, useRouter } from "vue-router";
import Service from "../../../../../modules/Inventory/Service/StockOutService";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import stockinservice from "../../../../../modules/Inventory/Service/StockInService";
import AutoCompleteCustom from "../../../../../components/FormComponents/AutoComplete.vue";
import listservice from "../../../../../modules/Inventory/Service/StockInService";
import listserviceOut from "../../../../../modules/Inventory/Service/StockOutService";
import common from "../../../../../modules/Inventory/Service/CommonService";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
// import GRNRItem from "./GRNRItem.vue";
import GRNRItem from "../../../../../modules/Inventory/pages/Transaction/StockOut/GRNRItem.vue";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import Cancel from "../../../../../components/GeneralButtons/CancelButtton.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import FooterSection from "../../../../../modules/Inventory/components/Transaction/stockin/FooterSection.vue";
import GRNReturn from "../../../../../modules/Inventory/pages/Transaction/StockOut/GRNReturn.vue";
import Itemservice from "../../../../../modules/Inventory/Service/ItemMasService";
import AlreadyExist from "../../../../../components/FormComponents/AlreadyExist.vue";
import { after } from "node:test";

export default defineComponent({
  components: {
    BackBtn,
    Headerlayout,
    Tableview,
    Supplier,
    Items,
    Footer,
    PurchaseOrder,
    Return,
    CustomDropdown,
    Datepicker,
    AutoCompleteCustom,
    TextField,
    EditConfirmation,
    GRNRItem,
    CreateSuccessully,
    UpdatedSuccessfully,
    Cancel,
    CrystalReportPrintPopUp,
    FooterSection,
    AlreadyExist,
  },

  setup() {
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    const toast = useToast();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const dataItems = ref({});
    const itemDatas = ref([]);
    const displayClass = ref("");
    const aboveContainer = ref();
    const aboveContainerMarginLeft = ref("");
    const route = useRoute();
    let StoreId = route.query.StoreId ?? 0;
    let status = route.query.status ?? 0;
    let Type = route.query.Type;
    let StoreBrMapId = route.query.storebranchmapid ?? 0;
    const dupitems: any = ref([]);
    let SaveLoader = ref(false);

    let IsGRNDetails = route.query.IsGRNDetails ?? 0;
    let colourCodeList = ref([
      { OrderColor: "red", StatusName: "No Stock" },
      { OrderColor: "blue", StatusName: "Partially Issued" },
      { OrderColor: "green", StatusName: "Issued" },
    ]);
    let OperationId = Number(route.query.OperationId) ?? 0;
    let Entitydata = ref();
    Entitydata.value = Number(route.query.EntityId) ?? 0;
    const router = useRouter();
    let items: any = ref([]);
    var arr: any = [];
    var supcategory = ref();
    let LoadItemName = ref({ ITEMoption: [], ITEMid: null });
    const CrystalReportPopup = ref(false);

    let QueryStringValue3: any = route.query;
    let StoreID = QueryStringValue3["StoreId"];
    let queryBranchId = QueryStringValue3["BranchId"] ?? 0;

    const taxvalues: any = ref([]);
    let overallTax = ref(0);

    let HiddenRefNo = route.query.refNo;

    const now = new Date();

    let DisableObj = ref({
      Supplier:
        HiddenRefNo == "" && QueryStringValue3["Id"] == 0 ? false : true,
      GRNNumberColumn: HiddenRefNo != "" || IsGRNDetails == 1 ? "d-none" : "",
    });

    let List = ref([]);

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    const GRNForm = ref({
      refNo: "",
      docDate: "",
      GRNDocDate: "",
      disabled: false,
      disableddate: false,
    });
    const returnOption = ref([
      {
        name: "Replacement",
        value: 1,
      },
      {
        name: "Debit Note",
        value: 2,
      },
    ]);
    const popup = ref({
      successpop: false,
      updatepop: false,
    });

    let Itemgroup = ref({
      ItemName: "",
      ItemQuantity: "",
    });

    const commonProps = ref({
      storeId: 0,
    });

    const commonItemProps = ref({
      storeId: "",
      type: 1,
      fieldType: 1,
      itemType: 1,
      requestType: 1,
      barcodeType: 1, //1-load item with barcode based on requested item(filter based on barcode)
      IsFilter: 2,
      SupllierStateId: 0,
      tostoreId: 0,
      GRNReturnFlag: true,
      UOMFlag: true,
    });
    const alreadyexistpop = ref(false);
    let afterSave = ref(false);
    let selectedcontent = ref("Some Items has no stock");
    commonItemProps.value.storeId = QueryStringValue3["StoreId"];
    commonProps.value.storeId = QueryStringValue3["StoreId"];

    const headers = [
      {
        header: t("storetabdetails.grnreturncreationtable.GRNNumber"),
        field: "DocNo",
        class: DisableObj.value.GRNNumberColumn,
      },
      {
        header: t("storetabdetails.grnreturncreationtable.Code"),
        field: "ItemCode",
        class: "smallwidth newcolumnfreezeleft1",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.Name"),
        field: "Itemname1",
        slot: "Itemname1",
        fieldDisplay: "false",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft2",
      },
      {
        header: t(
          "storetabdetails.grnreturncreationtable.Brand/ModelNumber/Size"
        ),
        field: "BrandName",
        fieldDisplay: "false",
        slot: "combinedFieldSlot",
        class: "newcolumnfreezeleft3",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.MRP"),
        field: "MRP",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.UOM"),
        field: "UOMName",
        class: "smallwidth",
      },
      {
        header: "GRN Qty",
        field: "GRNRecQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.Qty"),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: t('storetabdetails.grnreturncreationtable.POQty'),
      //   field: "RequestedQty",
      //   // class: paramnames == "GRN With PO" ? "smallwidth" : "d-none",
      //   bodyclass: "right_td",
      // },
      {
        header: t("storetabdetails.grnreturncreationtable.HSN"),
        field: "HSNCode",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.PurchasingUnit"),
        field: "PurchaseUnitName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.BatchNo"),
        field: "BatchNo",
        // slot: "BatchNo",
        // sortable: false,
        // fieldDisplay: "false",
        class: "smallwidth",

        // class: "minWidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.ExpiryDate"),
        field: "ExpiryDate",
        slot: "ExpiryDateslot",
        // sortable: false,
        fieldDisplay: "false",
        class: "mediumwidth newcolumnfreezeleft4",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.UnitRate"),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Rate",
      //   field: "Rate",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: t("storetabdetails.grnreturncreationtable.Rate"),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.ServiceCharges"),
        field: "servicecharges",
        // slot: "servicecharges",
        // sortable: false,
        // fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth",
        // class: "minWidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.OtherCharges"),
        field: "othercharges",
        // slot: "othercharges",
        // sortable: false,
        // fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth",
        // class: "minWidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.Discount%"),
        field: "Discount",
        // slot: "Discount",
        // sortable: false,
        // fieldDisplay: "false",
        // class: "minWidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.Discount"),
        field: "Discountamount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.Tax%"),
        field: "PurchasePercentage",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.Tax"),
        field: "Purchasetaxamount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.SGST%"),
        field: "SGSTTax",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.SGST"),
        field: "SGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.CGST%"),
        field: "CGSTTax",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.CGST"),
        field: "CGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.IGST%"),
        field: "IGSTTax",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.IGST"),
        field: "IGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.TotalValue"),
        field: "Totalvalue",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.ReturnReason"),
        field: "ReasonName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturncreationtable.BinLocation"),
        field: "BinLocation",
        fieldDisplay: "false",
        slot: "combinedBin",
      },
      {
        header: "Replacement Status",
        field: "ReplacementStatus",
        fieldDisplay: "false",
        slot: "ReplacementStatusSlot",
      },
      {
        field: "action",
        // header: "Action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position",
        fieldDisplay: "false",
      },
    ];

    const createrequestForm = ref({
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      ApprovalDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      TaskExpiryDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Id: 0,
      DocType: "12",
      DocNo: "",
      DocDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      StoreId: 0,
      DcDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      InvoiceDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      InWardDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      RefId: 0,
      Amount: 0.0,
      RefNo: "",
      SupplierId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      ReturnType: ref(),
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      grossamount: 0.0,
      taxamount: 0.0,
      totaldiscountamount: 0.0,
      transportcharges: 0.0,
      servicecharges: 0.0,
      othercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
      freightcharges: 0.0,
      InvoiceNo: "",
      IsDraft: 0,
      StockOutDetailList: [],
    });

    const SupformData = ref({
      SupplierId: ref(),
    });

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: items },
      SupplierCategory: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    let showFields = {
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: false,
        require: false,
      },
      PackSize: {
        show: true,
        require: false,
      },
      UnitRate: {
        show: false,
        require: false,
      },
      Qty: {
        show: true,
        require: true,
      },
      MRP: {
        show: false,
        require: false,
      },
      Discount: {
        show: false,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      Reason: {
        show: true,
        require: true,
      },
      GrnAvlQty: {
        show: true,
        require: true,
        fieldName: "GRN Quantity",
      },
      UOM: {
        show: true,
        require: true,
      },
    };

    async function grnautogen() {
      debugger;
      try {
        debugger;
        console.log(GRNForm.value.refNo);

        const dataresponse = await stockinservice.listStockInMasterTM(
          GRNForm.value.refNo,
          "7,8",
          StoreId
        );
        console.log(dataresponse);
        supcategory.value = dataresponse["result"].map((item: any) => {
          item.label = item.DocNo;
          item.value = item.Id;
          return item;
        });
        console.log(supcategory.value);
      } catch (error) {
        console.log(error);
      }
    }

    let Detailslist;
    async function getSupplier(supvalue) {
      debugger;
      if (supvalue["SupplierId"] != 0) {
        Detailslist = await listservice.getlistBySupplierId(
          supvalue.SupplierId
        );
        console.log(Detailslist);
        SupformData.value.SupplierId = Detailslist["result"][0].SupplierId;
        itemDatas.value = Detailslist["result"].map((item) => {
          item.OrgItemsQty = Number(item.ItemQuantity);

          return item;
        });

        createrequestForm.value.SupplierId =
          Detailslist["result"][0].SupplierId;
        commonItemProps.value.SupllierStateId =
          Detailslist["result"][0].StateId;
      } else {
        itemDatas.value = [];
      }
    }

    async function ongrnchange(data: any) {
      debugger;
      console.log(data.value);
      console.log(data.value.DocNo);
      console.log(data.value.Id);
      Detailslist = await listservice.getlistById(data.value.Id);
      console.log(Detailslist);
      SupformData.value.SupplierId = Detailslist["result"][0].SupplierId;
      itemDatas.value = Detailslist["result"].map((item) => {
        // item.OrgItemsQty = (Number(item.ItemQuantity) - Number(item.ReturnsQty || 0)) / Number(item.PackSizeQty || 1);
        item.OrgItemsQty = Number(item.ItemQuantity);

        // item.IssuedQty = (Number(item.ItemQuantity) - Number(item.ReturnsQty || 0)) / Number(item.PackSizeQty || 1);

        return item;
      });
      createrequestForm.value.RefId = data.value.Id;
      createrequestForm.value.RefNo = data.value.DocNo;
      createrequestForm.value.SupplierId = Detailslist["result"][0].SupplierId;
    }

    // function IsAdd() {
    //   debugger;
    //   let itemCount: number = items.value.filter(
    //     (item) => item.ItemId == Itemgroup.value.ItemName
    //   ).length;
    //   if (itemCount > 0) {
    //     Editmodel.value = true;
    //   } else {
    //     // AddItems();
    //     Add();
    //   }
    // }

    onMounted(() => {
      debugger;
      let QueryStringValue4: any = route.query;
      GetCode();
      GRNForm.value.docDate = moment(now).format("D MMMM YYYY");
      if (Number(QueryStringValue4["RefId"])) {
        grnNo();
      }
      if (QueryStringValue4["Id"]) {
        IsEdit();
      }
    });

    const Add = (value) => {
      debugger;
      console.log(value);
      items.value = value;
      debugger;
      let index = items.value.length - 1;
      createrequestForm.value.grossamount += Number(items.value[index]["Rate"]);
      createrequestForm.value.taxamount += Number(
        items.value[index]["Purchasetaxamount"]
      );
      createrequestForm.value.totaldiscountamount += Number(
        items.value[index]["Discountamount"]
      );
      createrequestForm.value.servicecharges += Number(
        items.value[index]["servicecharges"]
      );
      createrequestForm.value.othercharges += Number(
        items.value[index]["othercharges"]
      );
      createrequestForm.value.totalqty += Number(
        items.value[index]["ItemQuantity"]
      );
      createrequestForm.value.netamount +=
        createrequestForm.value.grossamount +
        createrequestForm.value.taxamount +
        createrequestForm.value.servicecharges +
        createrequestForm.value.othercharges -
        createrequestForm.value.totaldiscountamount;
    };
    const GRNRCalcDetails: any = ref({
      TotalAmount: 0.0,
    });

    function debounce<T extends (...args: any[]) => void>(
      func: T,
      wait: number
    ) {
      let timeout: ReturnType<typeof setTimeout>;

      return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    const debouncedGRNRcalculation = debounce(GRNRcalculation, 300);

    watch(
      items,
      (newItems, oldItems) => {
        debugger;
        if (items.value.length > 0) {
          debouncedGRNRcalculation();
        }
      },
      { deep: true }
    );

    async function GRNRcalculation() {
      debugger;
      await GRNRCalcDetailsClear();

      for (let i = 0; i < items.value.length; i++) {
        GRNRCalcDetails.value.TotalAmount += parseFloat(
          items.value[i]["Totalvalue"]
        );
      }
      GRNRCalcDetails.value.TotalAmount = Number(
        GRNRCalcDetails.value.TotalAmount
      ).toFixed(2);
    }

    function GRNRCalcDetailsClear() {
      debugger;

      GRNRCalcDetails.value.TotalAmount = 0.0;
    }

    function addQuantity() {
      debugger;

      Object.values(items.value).forEach((item: any) => {
        if (item.ItemId === Itemgroup.value.ItemName) {
          item.ItemQuantity =
            parseFloat(item.ItemQuantity) +
            parseFloat(Itemgroup.value.ItemQuantity);
        }
      });
      Editmodel.value = false;
      IsClear();
      alert("Quantity Added Successfully");
    }

    async function grnNo() {
      debugger;
      GRNForm.value.refNo = QueryStringValue3["refNo"];
      GRNForm.value.disabled = true;
      Detailslist = await listservice.getlistById(QueryStringValue3["RefId"]);
      createrequestForm.value.RefId = QueryStringValue3["RefId"];
      createrequestForm.value.RefNo = QueryStringValue3["refNo"];
      createrequestForm.value.StoreBrMapId =
        Detailslist["result"][0]["StoreBrMapId"];
      createrequestForm.value.FromStoreBrMapId =
        Detailslist["result"][0]["FromStoreBrMapId"];
      createrequestForm.value.ToStoreBrMapId =
        Detailslist["result"][0]["ToStoreBrMapId"];
      createrequestForm.value.InvoiceNo = Detailslist["result"][0]["InvoiceNo"];

      GRNForm.value.GRNDocDate = moment(
        Detailslist["result"][0]["DocDate"],
        "DD-MM-YYYY"
      ).format("D MMMM YYYY");

      console.log(Detailslist);
      SupformData.value.SupplierId = Detailslist["result"][0].SupplierId;
      console.log(GRNForm.value.refNo);
      let StockTransId = QueryStringValue3["RefId"];
      console.log(QueryStringValue3["RefId"]);
      IsShowByStockTransId(StockTransId);
    }

    async function IsEdit() {
      debugger;
      Detailslist = await listserviceOut.GetById(QueryStringValue3["Id"]);
      createrequestForm.value.Id = QueryStringValue3["Id"];
      createrequestForm.value.ReturnType =
        Detailslist["result"][0]["ReturnType"];
      GRNForm.value.refNo = Detailslist["result"][0]["RefNo"];
      GRNForm.value.disabled = true;
      GRNForm.value.disableddate = true;
      GRNForm.value.docDate = moment(
        Detailslist["result"][0]["DocDate"],
        "DD-MM-YYYY"
      ).format("D MMMM YYYY");
      createrequestForm.value.DocNo = Detailslist["result"][0]["DocNo"];
      createrequestForm.value.RefId = Detailslist["result"][0]["RefId"];
      createrequestForm.value.RefNo = Detailslist["result"][0]["RefNo"];
      createrequestForm.value.IsDraft = Detailslist["result"][0]["IsDraft"];

      (GRNForm.value.GRNDocDate = Detailslist["result"][0]["GRNDate"]),
        console.log(Detailslist);
      SupformData.value.SupplierId = Detailslist["result"][0].SupplierId;

      console.log(GRNForm.value.refNo);
      Detailslist["result"] = Detailslist["result"].map((item) => {
        item.Totalvalue =
          Number(item.UnitRate) * Number(item.ItemQuantity) +
          Number(item.Purchasetaxamount);
        return item;
      });
      items.value = Detailslist["result"].map((item) => ({
        ...item,
        Discountamount: item.DiscountAmount1.toFixed(2),
        othercharges: item.OtherCharges.toFixed(2),
        servicecharges: item.ServiceCharges.toFixed(2),
        SGSTTaxAmount: item.SGSTTaxAmount.toFixed(2),
        CGSTTaxAmount: item.CGSTTaxAmount.toFixed(2),
        IGSTTaxAmount: item.IGSTTaxAmount.toFixed(2),
        GRNRecQty: item.ReceivedQty,
        GrnAvlQty: item.StockInHand,
        //  ReasonName:
        //   item.ReturnReason == 1
        //     ? "Expired"
        //     : item.ReturnReason == 2
        //       ? "Damage"
        //      : "Non moveable",
      }));
      items.value.Discountamount = Detailslist["result"][0]["DiscountAmount1"];
      let StockTransId = Detailslist["result"][0]["RefId"];
      console.log(QueryStringValue3["Id"]);
      IsShowByStockTransId(StockTransId);
      Add(items.value);
      //  DisableObj.value.Supplier = true;
    }

    async function IsShowByStockTransId(StockTransId) {
      debugger;

      const result = await stockinservice.getlistById(StockTransId);
      console.log(result["result"]);
      itemDatas.value = result["result"].map((item) => {
        // item.OrgItemsQty = (Number(item.ItemQuantity) - Number(item.ReturnsQty || 0)) / Number(item.PackSizeQty || 1);
        // item.IssuedQty = (Number(item.ItemQuantity) - Number(item.ReturnsQty || 0)) / Number(item.PackSizeQty || 1);
        // item.ItemQuantity = item.IssuedQty;
        // item.RecievedQty = item.PoQty;
        item.OrgItemsQty = Number(item.ItemQuantity);
        // item.IssuedQty = item.GrnAvlQty;
        return item;
      });
    }
    async function GetCode() {
      debugger;
      let data = {
        EntityId: Entitydata.value,
        HospitalId: HospitalId,
        BranchId: queryBranchId,
        StoreId: StoreID ?? 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      createrequestForm.value.DocNo = result;
    }

    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      SaveLoader.value = true;
      let checkstockAvailabilityresult: any;

      createrequestForm.value.CreatedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      createrequestForm.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      createrequestForm.value.BranchId = queryBranchId;
      createrequestForm.value.HospitalId = HospitalId;
      createrequestForm.value.ModifiedBy = UserId;
      createrequestForm.value.CreatedBy = UserId;
      createrequestForm.value.EntityId = Number(Entitydata.value);
      createrequestForm.value.EntityOperationId = OperationId;

      createrequestForm.value.Amount = GRNRCalcDetails.value.TotalAmount;
      createrequestForm.value.RefId = QueryStringValue3["RefId"];
      createrequestForm.value.RefNo = QueryStringValue3["refNo"];
      createrequestForm.value.StoreBrMapId = Number(StoreBrMapId);
      createrequestForm.value.IsDraft = 0;

      let result,
        message,
        id = 0;
      debugger;
      checkstockAvailabilityresult = await Itemservice.CheckstockAvailability(
        items.value.filter((item) => item.ItemQuantity > 0)
      );
      debugger;
      const hasStockStatusOneOrTwo = checkstockAvailabilityresult[
        "result"
      ].some((item) => item.StockStatus === 1 || item.StockStatus === 2);
      const hasStockStatusZeroOrOne = checkstockAvailabilityresult[
        "result"
      ].some((item) => item.StockStatus === 0 || item.StockStatus === 1);
      debugger;
      items.value = items.value.map((item) => {
        const stockItem = checkstockAvailabilityresult["result"].find(
          (s) =>
            s.ItemId === item.ItemId &&
            s.Brand === item.Brand &&
            s.ModelNumber === item.ModelNumber &&
            s.Size === item.Size
        );

        if (stockItem) {
          return {
            ...item,
            StockStatus: stockItem.StockStatus,
            ItemQuantity:
              stockItem.StockStatus === 1
                ? stockItem.StockInHand
                : stockItem.StockStatus === 0
                ? 0
                : item.ItemQuantity,
          };
        }
        return item;
      });

      if (hasStockStatusOneOrTwo) {
        if (QueryStringValue3["Id"] != 0) {
          createrequestForm.value.Id = QueryStringValue3["Id"];
        }

        if (items.value.length > 0) {
          createrequestForm.value.SupplierId = SupformData.value.SupplierId;
          console.log(createrequestForm.value);
          createrequestForm.value.StoreId = QueryStringValue3["StoreId"];
          for (let i = 0; i < items.value.length; i++) {
            let obj = {};
            if (items.value[i]["ItemQuantity"] != 0) {
              (obj["ItemId"] = items.value[i]["ItemId"]),
                (obj["PoQty"] = items.value[i]["ItemQuantity"]),
                (obj["Qty"] = parseInt(items.value[i]["ItemQuantity"])),
                (obj["RefId"] = id),
                (obj["PackSizeId"] = items.value[i]["PackageSizeId"]),
                (obj["HSNId"] = items.value[i]["HSNId"]),
                (obj["UnitRate"] =
                  items.value[i]["UnitRate"] == null
                    ? 0
                    : items.value[i]["UnitRate"]),
                (obj["TaxId"] = items.value[i]["PurchaseUnit"]),
                (obj["CreatedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["ModifiedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["CreatedBy"] = UserId),
                (obj["ModifiedBy"] = UserId),
                (obj["ExpiryDate"] =
                  items.value[i]["ExpiryDate"] != "01-01-0001" &&
                  items.value[i]["ExpiryDate"] != "" &&
                  items.value[i]["ExpiryDate"] != undefined
                    ? (obj["ExpiryDate"] = moment(
                        items.value[i]["ExpiryDate"],
                        "DD-MM-YYYY"
                      ).format("YYYY-MM-DD"))
                    : "1900-01-01T19:17:58.632+05:30"),
                (obj["BarCodeNo"] = items.value[i]["BarCodeNo"]),
                (obj["BarCode"] = items.value[i]["BarCode"]),
                (obj["UnitRate"] = items.value[i]["UnitRate"]);
              obj["PurchaseTax"] = items.value[i]["PurchasePercentage"];
              obj["PurchaseTaxAmount"] = items.value[i]["Purchasetaxamount"];
              obj["SalesTax"] = items.value[i]["SalestaxPercentage"];
              obj["SalesTaxAmount"] = items.value[i]["Salestaxamount"];
              obj["DiscountPer"] = items.value[i]["Discount"];
              obj["DiscountAmount"] = items.value[i]["DiscountAmount"];
              obj["TotalValue"] = items.value[i]["Totalvalue"];
              obj["Id"] = items.value[i]["StockOutDetailId"];
              obj["GRNId"] = items.value[i]["GRNId"];
              obj["GRNNo"] = items.value[i]["DocNo"];
              obj["ReturnReason"] = items.value[i]["ReasonId"];
              obj["IsApproved"] = 1;
              obj["SGSTTax"] = items.value[i]["SGSTTax"];
              obj["SGSTTaxAmount"] = items.value[i]["SGSTTaxAmount"];
              obj["CGSTTax"] = items.value[i]["CGSTTax"];
              obj["CGSTTaxAmount"] = items.value[i]["CGSTTaxAmount"];
              obj["IGSTTax"] = items.value[i]["IGSTTax"];
              obj["IGSTTaxAmount"] = items.value[i]["IGSTTaxAmount"];
              obj["Rate"] = items.value[i]["Rate"];
              obj["UnitMRP"] = items.value[i]["MRP"];
              obj["BatchNo"] = items.value[i]["BatchNo"];
              obj["RoomId"] = items.value[i]["RoomId"];
              obj["RackId"] = items.value[i]["RackId"];
              obj["RowId"] = items.value[i]["RowId"];
              obj["BoxId"] = items.value[i]["BoxId"];
              obj["UOM"] = items.value[i]["UOM"];
              (obj["Brand"] =
                items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"]),
                (obj["ModelNumber"] =
                  items.value[i]["ModelNumber"] == null
                    ? 0
                    : items.value[i]["ModelNumber"]),
                (obj["Size"] =
                  items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);
              arr[i] = obj;
            }
          }
          console.log(arr);

          createrequestForm.value.StockOutDetailList = arr;

          result = await Service.creatStockOutMasterTMDraft(
            createrequestForm.value
          );
          id = result["result"][0].Id;
          createrequestForm.value.Id = id;
          for (
            let i = 0;
            i < createrequestForm.value.StockOutDetailList.length;
            i++
          ) {
            const ResultList = result["result"][0];
            items.value[items.value.length - 1].Id =
              ResultList.StockOutDetailList[0]["Id"];
            items.value[items.value.length - 1].StockOutDetailId =
              ResultList.StockOutDetailList[0]["Id"];
          }

          let msgMapping = result["ErrorInfo"].ErrorCode;
          if (msgMapping == null) {
            if (hasStockStatusZeroOrOne) {
              alreadyexistpop.value = true;
              SaveLoader.value = false;
              afterSave.value = true;
            } else {
              if (QueryStringValue3["Id"] != 0) {
                PrintCrystalReport(id);
                popup.value.updatepop = true;
              } else {
                PrintCrystalReport(id);
                popup.value.successpop = true;
              }
              SaveLoader.value = false;
            }
          }
          // }
        } else {
          toast.add({
            severity: "warn",
            summary: "Please Add the Item",
            detail: "",
            life: 3000,
          });
          SaveLoader.value = false;
        }
      } else {
        alreadyexistpop.value = true;
        SaveLoader.value = false;
        afterSave.value = true;
      }

      // }
      // IstableClear()
    });

    const IsSubmitDraft = handleSubmit(async (values) => {
      debugger;
      createrequestForm.value.CreatedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      createrequestForm.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      createrequestForm.value.BranchId = queryBranchId;
      createrequestForm.value.HospitalId = HospitalId;
      createrequestForm.value.ModifiedBy = UserId;
      createrequestForm.value.CreatedBy = UserId;
      createrequestForm.value.EntityId = Number(Entitydata.value);
      createrequestForm.value.EntityOperationId = OperationId;

      createrequestForm.value.Amount = GRNRCalcDetails.value.TotalAmount;
      createrequestForm.value.RefId = QueryStringValue3["RefId"];
      createrequestForm.value.RefNo = QueryStringValue3["refNo"];
      createrequestForm.value.StoreBrMapId = Number(StoreBrMapId);
      createrequestForm.value.IsDraft = 1;

      let result,
        message,
        id = 0;
      // if (QueryStringValue3['Id'] != 0) {
      //   createrequestForm.value.Id = QueryStringValue3['Id'];
      //   let result = await Service.updateGRNReturn(createrequestForm.value);
      //   let msgMapping = result["ErrorInfo"].ErrorCode;
      //   if (msgMapping == null) {
      //     popup.value.updatepop = true;
      //   }
      // }
      // else {
      if (items.value.length > 0) {
        createrequestForm.value.SupplierId = SupformData.value.SupplierId;
        console.log(createrequestForm.value);
        createrequestForm.value.StoreId = QueryStringValue3["StoreId"];
        // if (createrequestForm.value.Id && createrequestForm.value.Id != 0) {
        //   result = await Service.updateStockOutMasterTM(
        //     createrequestForm.value
        //   );
        //   id = createrequestForm.value.Id;
        // } else {

        // message = result["ErrorInfo"].ErrorCode;

        // if (message == null) {
        //   debugger;
        for (let i = 0; i < items.value.length; i++) {
          let obj = {};
          (obj["ItemId"] = items.value[i]["ItemId"]),
            (obj["PoQty"] = items.value[i]["ItemQuantity"]),
            (obj["Qty"] =
              parseInt(items.value[i]["ItemQuantity"]) *
              items.value[i]["PackSizeQty"]),
            (obj["RefId"] = id),
            (obj["PackSizeId"] = items.value[i]["PackageSizeId"]),
            (obj["HSNId"] = items.value[i]["HSNId"]),
            // obj["TaxId"] = items.value[i]['TaxId'],
            (obj["UnitRate"] =
              items.value[i]["UnitRate"] == null
                ? 0
                : items.value[i]["UnitRate"]),
            (obj["TaxId"] = items.value[i]["PurchaseUnit"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),
            (obj["ExpiryDate"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["BarCodeNo"] = items.value[i]["BarCodeNo"]),
            (obj["BarCode"] = items.value[i]["BarCode"]),
            (obj["UnitRate"] = items.value[i]["UnitRate"]);
          obj["PurchaseTax"] = items.value[i]["PurchasePercentage"];
          obj["PurchaseTaxAmount"] = items.value[i]["Purchasetaxamount"];
          obj["SalesTax"] = items.value[i]["SalestaxPercentage"];
          obj["SalesTaxAmount"] = items.value[i]["Salestaxamount"];
          obj["DiscountPer"] = items.value[i]["Discount"];
          obj["DiscountAmount"] = items.value[i]["DiscountAmount"];
          obj["TotalValue"] = items.value[i]["Totalvalue"];
          obj["Id"] = items.value[i]["StockOutDetailId"];

          obj["GRNId"] = items.value[i]["GRNId"];
          obj["GRNNo"] = items.value[i]["DocNo"];
          obj["ReturnReason"] = items.value[i]["ReasonId"];
          obj["IsApproved"] = 1;
          obj["SGSTTax"] = items.value[i]["SGSTTax"];
          obj["SGSTTaxAmount"] = items.value[i]["SGSTTaxAmount"];
          obj["CGSTTax"] = items.value[i]["CGSTTax"];
          obj["CGSTTaxAmount"] = items.value[i]["CGSTTaxAmount"];
          obj["IGSTTax"] = items.value[i]["IGSTTax"];
          obj["IGSTTaxAmount"] = items.value[i]["IGSTTaxAmount"];
          obj["Rate"] = items.value[i]["Rate"];
          obj["UnitMRP"] = items.value[i]["MRP"];
          obj["BatchNo"] = items.value[i]["BatchNo"];
          obj["RoomId"] = items.value[i]["RoomId"];
          obj["RackId"] = items.value[i]["RackId"];
          obj["RowId"] = items.value[i]["RowId"];
          obj["BoxId"] = items.value[i]["BoxId"];
          (obj["Brand"] =
            items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"]),
            (obj["ModelNumber"] =
              items.value[i]["ModelNumber"] == null
                ? 0
                : items.value[i]["ModelNumber"]),
            (obj["Size"] =
              items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);

          arr[i] = obj;
        }
        console.log(arr);

        createrequestForm.value.StockOutDetailList = arr;

        result = await Service.creatStockOutMasterTMDraft(
          createrequestForm.value
        );
        id = result["result"][0].Id;
        createrequestForm.value.Id = id;
        for (
          let i = 0;
          i < createrequestForm.value.StockOutDetailList.length;
          i++
        ) {
          const ResultList = result["result"][0];
          items.value[items.value.length - 1].Id =
            ResultList.StockOutDetailList[0]["Id"];
          items.value[items.value.length - 1].StockOutDetailId =
            ResultList.StockOutDetailList[0]["Id"];
        }

        let msgMapping = result["ErrorInfo"].ErrorCode;
        // if (msgMapping == null) {
        //   if (createrequestForm.value.Id && createrequestForm.value.Id != 0) {
        //     popup.value.updatepop = true;
        //   } else {
        //     PrintCrystalReport(id);
        //     popup.value.successpop = true;
        //   }
        // }
        // }
      } else {
        toast.add({
          severity: "warn",
          summary: "Please Add the Item",
          detail: "",
          life: 3000,
        });
      }
      // }
      // IstableClear()
    });

    function closetrigger() {
      // successpop.value = false;
      // updatepop.value = false;
      setupHistoryManagement(router, 2);
      // router.push({
      //   name: "StoreTabDetails",
      //   query: {
      //     status: status,
      //     Id: StoreId,
      //     Type: Type,
      //   },
      // });
    }
    const copyinsert_data = JSON.parse(JSON.stringify(Itemgroup));

    function IsClear() {
      // Object.assign(Itemgroup, copyinsert_data);
      Itemgroup.value.ItemName = "";
      Itemgroup.value.ItemQuantity = "";
    }
    function IstableClear() {
      (items.value = ""), (GRNForm.value.docDate = "");
      (GRNForm.value.refNo = ""), (SupformData.value.SupplierId = 0);
    }
    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      displayClass.value = "show";
    }
    //Item Delete
    async function IsItemDelete(data) {
      debugger;
      let msg = null;
      if (data["StockOutDetailId"]) {
        const result = await Service.DeleteStockOutDetailsTM(
          data["StockOutDetailId"]
        );
        msg = result["ErrorInfo"].ErrorCode;
      }

      if (msg == null) {
        createrequestForm.value.grossamount -= Number(data["Rate"]);
        createrequestForm.value.taxamount -= Number(data["Purchasetaxamount"]);
        createrequestForm.value.totaldiscountamount -= Number(
          data["Discountamount"]
        );
        createrequestForm.value.servicecharges -= Number(
          data["servicecharges"]
        );
        createrequestForm.value.othercharges -= Number(data["othercharges"]);
        createrequestForm.value.totalqty -= Number(data["ItemQuantity"]);
        createrequestForm.value.netamount -=
          Number(data["Rate"]) +
          Number(data["Purchasetaxamount"]) +
          Number(data["servicecharges"]) +
          Number(data["othercharges"]) -
          Number(data["Discountamount"]);
        items.value = items.value.filter(
          (item) => item["BarCodeNo"] !== data.BarCodeNo
        );
      }
      console.log(items.value);
    }

    const ParameterValues = ref({ Id: 0, BranchId: 0, HospitalId: 0 });
    const PrintType = ref({ Type: "S", FormId: 5, ModuleId: 3 });

    function PrintCrystalReport(Id) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Id;
      ParameterValues.value.BranchId = queryBranchId;
      ParameterValues.value.HospitalId = HospitalId;
    }

    const AddItems = async (value) => {
      debugger;
      console.log(value);
      items.value = value.map((obj) => ({
        ...obj,
        StockStatus: 3,
        StoreId: StoreId,
        BranchId: queryBranchId,
        HospitalId: HospitalId,
      }));
      dupitems.value = [];
      const lastIndex = Number(items.value.length - 1);
      dupitems.value.push(items.value[lastIndex]);
    };

    function TotalGrossCalc(value1) {
      debugger;
      let arrCount: any = [];

      createrequestForm.value.grossamount = value1.grossamount;
      createrequestForm.value.totalqty = value1.ItemQuantity; //(value1.totalqty).toFixed(2);
      createrequestForm.value.taxamount = value1.taxamount;
      //   +
      //   createrequestForm.GRNTransportationTax +
      // createrequestForm.GRNFreightTax;
      createrequestForm.value.totaldiscountamount = value1.totaldiscountamount;
      createrequestForm.value.othercharges = value1.totalothercharges;
      createrequestForm.value.transportcharges = value1.totaltransportcharges;
      createrequestForm.value.servicecharges = value1.totalservicecharges;
      createrequestForm.value.netamount = value1.netamount.toFixed(2);
      //value1.TransportCharges = value1.totaltransportcharges;

      GRNOverallAmountCal();
    }
    function GRNOverallAmountCal() {
      debugger;
      createrequestForm.value.netamount = Number(
        (
          createrequestForm.value.grossamount +
          createrequestForm.value.transportcharges +
          createrequestForm.value.othercharges +
          createrequestForm.value.servicecharges +
          createrequestForm.value.freightcharges +
          createrequestForm.value.taxamount -
          createrequestForm.value.totaldiscountamount
        ).toFixed(2)
      );
    }
    function taxCalculation(value) {
      debugger;
      let dataarr: any = [];
      taxvalues.value = [];
      let arrCount: any = [];
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }
    function getColorStyle(data) {
      // return data.IsFreeItem == 1 ? { color: "Red" } : {};
      if (data.StockStatus === 1) {
        return { color: "blue" };
      } else if (data.StockStatus === 0) {
        return { color: "red" };
      } else if (data.StockStatus === 2) {
        return { color: "green" };
      } else {
        return {}; // Default style (no color change)
      }
    }
    return {
      taxCalculation,
      TotalGrossCalc,
      GRNOverallAmountCal,
      AddItems,
      Entitydata,
      filters,
      globalFilterFields,
      filteredColumns,
      items,
      List,
      headers,
      paramValue,
      GRNForm,
      IsSubmit,
      showFields,
      SupformData,
      supcategory,
      ongrnchange,
      grnautogen,
      LoadItemName,
      Itemgroup,
      Add,
      createrequestForm,
      IsClear,
      Editmodel,
      // IsAdd,
      addQuantity,
      dataItems,
      itemDatas,
      commonItemProps,
      displayClass,
      IsItemEdit,
      IsItemDelete,
      popup,
      closetrigger,
      aboveContainer,
      aboveContainerMarginLeft,
      commonProps,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      returnOption,
      getSupplier,
      HiddenRefNo,
      DisableObj,
      QueryStringValue3,
      taxvalues,
      overallTax,
      IsGRNDetails,
      SaveLoader,
      alreadyexistpop,
      afterSave,
      selectedcontent,
      alreadyclosetrigger,
      colourCodeList,
      getColorStyle,
    };
  },
});
</script>

<style>
/* .table-container{
     margin-right: 0 !important;
  } */
.colourCodeStatusBg {
  background-color: #e9e7e7;
  padding: 10px 20px;
  border-radius: 5px;
  height: max-content;

  .confirmedicon {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }
}
</style>
